
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AppointmentCard from "./AppointmentCard";

interface Appointment {
  id: string;
  psychologist: {
    name: string;
    photoUrl: string;
  };
  date: string;
  time: string;
  duration: number;
  status: string;
  meetingUrl?: string;
}

interface AppointmentListProps {
  upcomingAppointments: Appointment[];
  pastAppointments: Appointment[];
}

const AppointmentList = ({ upcomingAppointments, pastAppointments }: AppointmentListProps) => {
  return (
    <Tabs defaultValue="upcoming" className="w-full">
      <TabsList className="mb-4">
        <TabsTrigger value="upcoming">Próximas</TabsTrigger>
        <TabsTrigger value="past">Histórico</TabsTrigger>
      </TabsList>
      
      <TabsContent value="upcoming" className="space-y-4">
        {upcomingAppointments.length > 0 ? (
          upcomingAppointments.map((appointment) => (
            <AppointmentCard
              key={appointment.id}
              id={appointment.id}
              psychologist={appointment.psychologist}
              status={appointment.status}
              date={appointment.date}
              time={appointment.time}
              duration={appointment.duration}
              meetingUrl={appointment.meetingUrl}
            />
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-muted-foreground mb-4">Você não possui consultas agendadas</p>
            <Button asChild>
              <Link to="/schedule">Agendar Consulta</Link>
            </Button>
          </div>
        )}
      </TabsContent>
      
      <TabsContent value="past" className="space-y-4">
        {pastAppointments.length > 0 ? (
          pastAppointments.map((appointment) => (
            <AppointmentCard
              key={appointment.id}
              id={appointment.id}
              psychologist={appointment.psychologist}
              status={appointment.status}
              date={appointment.date}
              time={appointment.time}
              duration={appointment.duration}
            />
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-muted-foreground">Você não possui histórico de consultas</p>
          </div>
        )}
      </TabsContent>
    </Tabs>
  );
};

export default AppointmentList;
